module.exports = __webpack_public_path__ + "static/media/4.b90f0a81.jpg";